<script>
    import {getStyleValue} from '../../Common/tools';
    import TextEditor from "../../Common/TextEditor.svelte";

    export let data, meta, globalStyle, onChange;

    function change(section, val) {
      onChange();
      data = Object.assign({}, data, {[section]: val});
    }
</script>

<tr>
    <th class="column column-st has-columns" width="{getStyleValue(globalStyle.width, 600)}">
        <table class="row" cellspacing="0" cellpadding="0">
            <tbody>
            <tr>
                <th class="column mobile-padding-bottom" style="padding-right: 20px; text-align: left;"
                    width="{getStyleValue(globalStyle.width, 600)*.5}">
                    <TextEditor bind:data={data.left} meta={meta} onChange={val => change('left', val)} emailEditor={true} />
                </th>
                <th class="column" style="padding-left: 20px; text-align: left;"
                    width="{getStyleValue(globalStyle.width, 600)*.5}">
                    <TextEditor bind:data={data.right} meta={meta} onChange={val => change('right', val)} emailEditor={true} />
                </th>
            </tr>
            </tbody>
        </table>
    </th>
</tr>
